import React from 'react';
import styles from './styles.module.styl';

const BetaBadge = () => (
  <span className={`badge badge-warning ${styles.badge}`}>
    Beta
  </span>
);

export default BetaBadge;
